import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'type',
})
export class FilterGeneralPipe implements PipeTransform {

    transform(value: any, modulo: string) {
        if (value) {
            switch (modulo) {
                case 'capitalize':
                    return value.substring(0, 1).toUpperCase() + value.substring(1);
                case 'date':
                    return moment.utc(value).format('DD/MM/YYYY');
                case 'change_boolean':
                    return (value) ? 'Si' : 'No';
            }
        }
        return '';
    }
}
